module.exports = __webpack_public_path__ + "img/Assurance-Extra-Complete-Disablement.b06d87ca.jpg";